"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getQueryParam;
exports.parseQueryString = void 0;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.string.trim.js");

require("core-js/modules/es.string.search.js");

var parseQueryString = function parseQueryString(queryString, paramName) {
  var trimValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (queryString.length > 1) {
    var queryStringParts = queryString.substring(1).split('&');

    for (var i = 0; i < queryStringParts.length; i += 1) {
      var partPair = queryStringParts[i].split('=');

      if (partPair[0] === paramName) {
        var paramValue = decodeURIComponent(partPair[1]);
        return trimValue ? paramValue.trim() : paramValue;
      }
    }
  }

  return '';
};
/**
 * get query param by name
 *
 * @param paramName - name of parameter to retrieve
 * @param trimValue - should trim string value
 */


exports.parseQueryString = parseQueryString;

function getQueryParam(paramName) {
  var trimValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var queryString = window.location.search.trim();
  return parseQueryString(queryString, paramName, trimValue);
}